import React, { useState } from 'react';
import { useTranslation } from "react-i18next";

function ThemeCard({ title, description, icon, level, isExpandable = false }) {
  const [expanded, setExpanded] = useState(false);
  const { t } = useTranslation("global");
  
  const toggleExpand = () => {
    setExpanded(!expanded);
  };
  
  return (
    <div 
      className={`bg-white rounded-lg shadow-md transition-all duration-300 overflow-hidden ${isExpandable ? 'cursor-pointer hover:shadow-lg' : ''}`}
      onClick={isExpandable ? toggleExpand : undefined}
      role={isExpandable ? "button" : undefined}
      aria-expanded={isExpandable ? expanded : undefined}
    >
      <div className="p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-full bg-blue-100 text-blue-800 flex items-center justify-center font-semibold text-lg">
            {icon}
          </div>
          <div className="flex-1">
            <h3 className="text-xl font-semibold font-heading">{title}</h3>
            {level && <span className="text-xs text-blue-600 font-semibold">{t("home.level-label", "Niveau")} {level}</span>}
          </div>
          {isExpandable && (
            <button 
              className="text-gray-500" 
              onClick={(e) => {
                e.stopPropagation();
                toggleExpand();
              }}
              aria-label={expanded ? `Collapse ${title} details` : `Expand ${title} details`}
              aria-expanded={expanded}
            >
              {expanded ? (
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                </svg>
              )}
            </button>
          )}
        </div>
        
        <p className="text-gray-600">{description}</p>
        
        {isExpandable && expanded && (
          <div className="mt-4 pt-4 border-t border-gray-100">
            <h4 className="font-semibold mb-2">{t("home.theme-standards", "Standards associés:")}</h4>
            <p className="text-sm text-gray-600">
              {t("home.theme-standards-description", "Basé sur les normes ISO et les meilleures pratiques internationales.")}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default ThemeCard;